import ky from 'ky'
export * from 'ky'
export default ky.extend({
  hooks: {
    beforeRequest: [
      request => {
        const tokenTag = document.querySelector('meta[name="csrf-token"]')

        if (tokenTag) {
          request.headers.set('X-CSRF-Token', tokenTag.attributes.content.value)
        } else {
          process.env.RAILS_ENV !== 'production' && console.warn('ky: No CSRF content tag!')
        }

        request.headers.set('Content-Type', 'application/json')
        request.headers.get('Key-Inflection') || request.headers.set('Key-Inflection', 'camel')
      }
    ]
  }
})
